var _ellipse, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicMositalmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 96,
    viewBox: "0 0 136 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.1306,
    cy: 26.9476,
    rx: 9.763,
    ry: 9.76299,
    fill: "#FFE7CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9204 36.3062C68.8874 35.1061 65.9464 31.3702 65.9464 26.9474C65.9464 22.5248 68.887 18.7891 72.9197 17.5888C72.0359 17.3258 71.0998 17.1846 70.1306 17.1846C64.7387 17.1846 60.3676 21.5556 60.3676 26.9476C60.3676 32.3395 64.7387 36.7106 70.1306 36.7106C71.1 36.7106 72.0364 36.5693 72.9204 36.3062Z",
    fill: "#F2D0B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4139 37.8354C55.7862 41.091 51.9999 47.1758 51.9999 54.1449V66C51.9999 66 55.6572 71.5 70.8286 71.5C85.9999 71.5 89.6572 66 89.6572 66V54.1449C89.6572 46.8312 85.4873 40.4915 79.3953 37.3735C76.9318 39.564 73.6869 40.8946 70.1311 40.8946C66.8327 40.8946 63.8017 39.7496 61.4139 37.8354Z",
    fill: "#BEBFBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3676 17C60.3676 14.7909 62.1585 13 64.3676 13H75.8936C78.1027 13 79.8936 14.7909 79.8936 17V24.1577C79.8936 24.1577 77.8015 21.3683 70.1306 21.3683C62.4597 21.3683 60.3676 24.1577 60.3676 24.1577V17Z",
    fill: "#BEBFBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 18C48.1797 18 54 24.0756 54 31.5703C54 34.0767 53.53 36.6654 52.1814 38.5312L41 54L29.8186 38.5312C28.5 36 28 33.8406 28 31.5703C28 24.0756 33.8203 18 41 18ZM41 25.8596C37.979 25.8596 35.5293 28.4168 35.5293 31.5703C35.5293 34.7238 37.979 37.281 41 37.281C44.0209 37.281 46.4707 34.7238 46.4707 31.5703C46.4707 28.4168 44.0209 25.8596 41 25.8596Z",
    fill: "#827657"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49C77 47.3431 78.3431 46 80 46H104C105.657 46 107 47.3431 107 49V82C107 83.6569 105.657 85 104 85H80C78.3431 85 77 83.6569 77 82V49Z",
    fill: "#F6F4F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 55,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#EBEBE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 60,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#EBEBE5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 70,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#EBEBE5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 75,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#EBEBE5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 65,
    width: 21,
    height: 2,
    rx: 1,
    fill: "#EBEBE5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 31,
    r: 8,
    fill: "#BEBFBC",
    stroke: "#F6F4F0",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 55,
    width: 8,
    height: 7,
    rx: 1,
    fill: "#B5A788"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicMositalmed);
export default __webpack_public_path__ + "static/media/clinic_mositalmed.81dff7c1be1efc1477990a5d70d512f8.svg";
export { ForwardRef as ReactComponent };